import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-end"
// Opens a horizontally scrolling container scrolled to its right end (the latest weeks).
export default class extends Controller {
  connect() {
    this.element.scrollLeft = this.element.scrollWidth
  }
}
